import AppRedirect from '../components/common/AppRedirect';

export default function DownloadRedirect() {
  return (
    <AppRedirect
      title="앱 다운로드 중..."
      subtitle="잠시만 기다려주세요"
      redirectingTitle="앱스토어로 이동합니다"
      redirectingSubtitle="olym 앱을 설치해주세요"
    />
  );
}
